import { AppHelper } from "../../appHelper"
import { Grid } from "../../core/components/grid";
import { DropDownList } from "../../core/components/dropDownList";
import { AppBaseProps, CommonApp, Context } from "../../core/components/commonApp";
import { Helper } from "../../core/util/helper";
import { ComponentHelper } from "../../core/util/componentHelper";
import { SheetEventType } from "../../../siteManagement/sheet";
import { General } from "../../../siteManagement/general";
import { Config } from "../../core/config/config";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";

export class EmailTemplateListApp extends React.Component<EmailTemplateListAppProps, any> {
    private _gridData: Array<EmailTemplateGridItem> = [];
    common = new AppHelper();
    setTabTitle = true;
    editEnabled = false;
    refreshEnabled = true;
    emailTemplatesOptions: kendo.ui.GridOptions = null;
    translations: StringKeyDictionary<string> = null;
    private _gridRef: Grid = null;
    private _currentContext: string = null;
    private _selectedItem: EmailTemplateGridItem = null;
    private _gridHolderRef = null;

    constructor(props) {
        super(props);
        this.common.init(this);
        this._currentContext = Helper.hasValue(this.props.context.templateType) && this.props.context.templateType !== "" ? this.props.context.templateType : null;
    }

    private _getGridData = () => {
        if (this._currentContext !== null) {
            HTTPService.get("EmailSender/GetAllTemplates?templateType=" + this._currentContext)
                .then(result => {
                    Helper.setArrayValues(this._gridData, result);
                    this.setState({});
                });
        }
    }

    private _registerRefAndAddClickListener = (ref) => {
        if (this.common.isWindow && this._gridHolderRef === null) {
            this._gridHolderRef = ref

            $(this._gridHolderRef).on("click", ".inno-select-command", (e) => {
                const sheet = General.Sheet.Manager.getTopMostSheet();
                sheet.trigger(SheetEventType.RowClicked, $(e.target).data("command-id"));
                sheet.hide();
            });
        }
    }

    private _selectionChanged = (dataItem: EmailTemplateGridItem) => {
        if (Helper.hasValue(dataItem)) {
            this.editEnabled = true;
            this._selectedItem = dataItem;
        } else {
            this.editEnabled = false;
            this._selectedItem = null;
        }
        this.setState({});
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.NEW) {
            this._openEditSheet(null);
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this._openEditSheet(dataItem);
        } else if (type === ToolBarStandardButtonType.DELETE) {
            this._remove();
        } else if (type === ToolBarStandardButtonType.RELOAD) {
            this._refresh();
        }
    }

    private _remove = async () => {
        if (await DialogHelper.confirm(this.translations["Standard.Msg.Loeschen"])) {
            HTTPService.post<JsonResultClass>("EmailSender/DeleteTemplate", { templateId: this._selectedItem.Id })
                .then(result => {
                    if (result.Code === 0) {
                        NotificationHelper.showSuccessMessage(result.Message);
                        this._selectedItem = null;
                        this.setState({}, () => {
                            this._refresh();
                        });
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
        }
    }

    private _openEditSheet = (dataItem: EmailTemplateGridItem) => {
        const url = Helper.hasValue(dataItem) ? ("EmailSender/EditTemplate/" + this._selectedItem.Id) : "EmailSender/NewTemplate/";

        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, null, true);
        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this._refresh();
        });
        General.Functions.HistoryState.pushSheetState(sheet, url);
    }

    private _refresh = () => {
        this._getGridData();
    }


    createGrid = () => {
        const ddlProps = ComponentHelper.createFactory().getDefaultDropDownProps();
        ddlProps.field.dataSourceUrl = "EmailSender/GetTemplateTypes";
        ddlProps.field.optionLabel = Config.translations.pleaseSelect;
        ddlProps.field.listWidth = null;
        ddlProps.value = this._currentContext;
        ddlProps.onDataLoaded = () => { };
        ddlProps.onChange = (field, value) => {
            this.editEnabled = false;
            if (Helper.hasValue(value) && value !== "") {
                this.refreshEnabled = true;
                this._currentContext = value;
                this._refresh();
            } else {
                this._currentContext = null;
                this._selectedItem = null;
                this.refreshEnabled = false;
                Helper.setArrayValues(this._gridData, null);
                this.setState({});
            }
        };

        if (this.common.isWindow && Array.isArray(this.emailTemplatesOptions.columns)) {
            let idx = -1;
            const cols = this.emailTemplatesOptions.columns;
            for (let i = 0; i < cols.length; i++) {
                if (cols[i].field === "Templatename") {
                    idx = i;
                    break;
                }
            }
            if (idx > -1) {
                cols[idx].template = "<a style='cursor:pointer;' class='inno-select-command' data-command-id='#=Id#'>#= Templatename #</a>";
            }
        }

        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: this.editEnabled });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.editEnabled });
        standardButtons.push({ type: ToolBarStandardButtonType.RELOAD, caption: Config.translations.reloadLabel, enabled: this.refreshEnabled });

        return (
            <div className="flex-container">
                {
                    this.common.isWindow ?
                        null :
                        <div style={{ marginBottom: "10px", marginTop: "10px", maxWidth: "400px", paddingLeft: "10px" }}>
                            <div className="flex-container flex-container--row flex-container--align-center">
                                <label style={{ marginRight: "20px" }}>{this.translations["WebCRM.Email.TemplateType"]}</label> <DropDownList {...ddlProps} />
                            </div>
                        </div>
                }
                <div className="flex-container__item flex-containter" ref={this._registerRefAndAddClickListener}>
                    <Grid
                        id="emailTemplateList"
                        data={this._gridData}
                        options={this.emailTemplatesOptions}
                        onSelectionChanged={this._selectionChanged}
                        standardButtons={standardButtons}
                        onClickStandardButton={this._handleClickStandardButton}
                        ref={(r) => this._gridRef = r} />
                </div>
            </div>
        );
    }

    componentDidMount() {
        this._refresh();
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
}

interface EmailTemplateGridItem {
    Id: number;
    Content: string;
    Name: string;
    Type: string;
}

interface EmailTemplateListAppContext extends Context {
    templateType: string;
}

export interface EmailTemplateListAppProps extends AppBaseProps {
    context: EmailTemplateListAppContext;
}
